import { Box, Image, Skeleton } from '@chakra-ui/react';
import { useContext, useState } from 'react';

import { MasterPlanImageContext } from '../ProjectZonePage';

import ZoneImg from 'img/sun-capital/Master plan/Ugreen/Type Building E/Ugreen zone.jpg';
import ZoneTypeC from 'img/sun-capital/Master plan/Ugreen/e1bd.svg';
import ZoneTypeD from 'img/sun-capital/Master plan/Ugreen/e2bd.svg';
import ZoneTypeE from 'img/sun-capital/Master plan/Ugreen/es.svg';

export default function Img() {
  const [isLoaded, setIsLoaded] = useState(false);

  const { typeName } = useContext(MasterPlanImageContext);

  return (
    <Skeleton
      w="100%"
      h="80%"
      flex={3}
      borderRadius={{ base: '1rem', mobile8: '2rem', tablet16: '3rem' }}
      isLoaded={isLoaded}
    >
      <Box
        position="relative"
        w="100%"
        h="100%"
        borderRadius={{ base: '1rem', mobile8: '2rem', tablet16: '3rem' }}
      >
        <Image
          onLoad={() => setIsLoaded(true)}
          w="100%"
          h="100%"
          borderRadius={{ base: '1rem', mobile8: '2rem', tablet16: '3rem' }}
          objectFit="cover"
          src={selectImage(typeName)}
        />
      </Box>
    </Skeleton>
  );
}

function selectImage(zoneType: string) {
  switch (zoneType) {
    case 'E-1BD':
      return ZoneTypeC;
    case 'E-2BD':
      return ZoneTypeD;
    case 'E-S':
      return ZoneTypeE;
    
    default:
      return ZoneImg;
  }
}
